import { PageError } from "@/PageError";
import { useGlobalError } from "@/shared/atoms/useGlobalError";
import React from "react";

const MyErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  const [error] = useGlobalError();

  if (error) {
    return <PageError error={error} />;
  }

  return <>{children}</>;
};

export default MyErrorBoundary;
